// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");
var Browser__Debugger$SmartcutsMacros = require("../browser/Browser__Debugger.bs.js");
var DevProtocol__Shared$SmartcutsMacros = require("./DevProtocol__Shared.bs.js");

var _map = {"keyDown":"keyDown","keyUp":"keyUp","rawKeyDown":"rawKeyDown","rawKeyUp":"rawKeyUp","char_":"char"};

var _revMap = {"keyDown":"keyDown","keyUp":"keyUp","rawKeyDown":"rawKeyDown","rawKeyUp":"rawKeyUp","char":"char_"};

function keyEventTypeToJs(param) {
  return _map[param];
}

function keyEventTypeFromJs(param) {
  return _revMap[param];
}

var DispatchKeyEvent = {};

function dispatchKeyEvent(type_, modifiers, timestamp, text, unmodifiedText, keyIdentifier, code, key, windowsVirtualKeyCode, nativeVirtualKeyCode, autoRepeat, isKeypad, isSystemKey, $$location, tabId, extensionId, targetId, param) {
  var tmp = {
    type: keyEventTypeToJs(type_)
  };
  if (modifiers !== undefined) {
    tmp.modifiers = Caml_option.valFromOption(modifiers);
  }
  if (timestamp !== undefined) {
    tmp.timestamp = Caml_option.valFromOption(timestamp);
  }
  if (text !== undefined) {
    tmp.text = Caml_option.valFromOption(text);
  }
  if (unmodifiedText !== undefined) {
    tmp.unmodifiedText = Caml_option.valFromOption(unmodifiedText);
  }
  if (keyIdentifier !== undefined) {
    tmp.keyIdentifier = Caml_option.valFromOption(keyIdentifier);
  }
  if (code !== undefined) {
    tmp.code = Caml_option.valFromOption(code);
  }
  if (key !== undefined) {
    tmp.key = Caml_option.valFromOption(key);
  }
  if (windowsVirtualKeyCode !== undefined) {
    tmp.windowsVirtualKeyCode = Caml_option.valFromOption(windowsVirtualKeyCode);
  }
  if (nativeVirtualKeyCode !== undefined) {
    tmp.nativeVirtualKeyCode = Caml_option.valFromOption(nativeVirtualKeyCode);
  }
  if (autoRepeat !== undefined) {
    tmp.autoRepeat = Caml_option.valFromOption(autoRepeat);
  }
  if (isKeypad !== undefined) {
    tmp.isKeypad = Caml_option.valFromOption(isKeypad);
  }
  if (isSystemKey !== undefined) {
    tmp.isSystemKey = Caml_option.valFromOption(isSystemKey);
  }
  if ($$location !== undefined) {
    tmp.location = Caml_option.valFromOption($$location);
  }
  var params = tmp;
  return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, "Input.dispatchKeyEvent", params).then(DevProtocol__Shared$SmartcutsMacros.sendCommandPromiseCallback);
}

var InsertTextParams = {};

function insertText(tabId, extensionId, targetId, text, param) {
  return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, "Input.insertText", {
                text: text
              }).then(DevProtocol__Shared$SmartcutsMacros.sendCommandPromiseCallback);
}

var _map$1 = {"mouse":"mouse","pen":"pen"};

function pointerTypeToJs(param) {
  return param;
}

function pointerTypeFromJs(param) {
  return _map$1[param];
}

var _map$2 = {"mousePressed":"mousePressed","mouseReleased":"mouseReleased","mouseMoved":"mouseMoved","mouseWheel":"mouseWheel"};

function type_ToJs(param) {
  return param;
}

function type_FromJs(param) {
  return _map$2[param];
}

var _map$3 = {"none":"none","left":"left","middle":"middle","left":"left"};

function buttonToJs(param) {
  return param;
}

function buttonFromJs(param) {
  return _map$3[param];
}

var DispatchMouseEvent = {
  pointerTypeToJs: pointerTypeToJs,
  pointerTypeFromJs: pointerTypeFromJs,
  type_ToJs: type_ToJs,
  type_FromJs: type_FromJs,
  buttonToJs: buttonToJs,
  buttonFromJs: buttonFromJs
};

function dispatchMouseEvent(tabId, extensionId, targetId, type_, x, y, modifiers, timestamp, button, buttons, clickCount, deltaX, deltaY, pointerType, param) {
  var tmp = {
    type: type_,
    x: x,
    y: y
  };
  if (modifiers !== undefined) {
    tmp.modifiers = Caml_option.valFromOption(modifiers);
  }
  if (timestamp !== undefined) {
    tmp.timestamp = Caml_option.valFromOption(timestamp);
  }
  var tmp$1 = OptionUtils$SmartcutsMacros.$neg$question$great(button, buttonToJs);
  if (tmp$1 !== undefined) {
    tmp.button = Caml_option.valFromOption(tmp$1);
  }
  if (buttons !== undefined) {
    tmp.buttons = Caml_option.valFromOption(buttons);
  }
  if (clickCount !== undefined) {
    tmp.clickCount = Caml_option.valFromOption(clickCount);
  }
  if (deltaX !== undefined) {
    tmp.deltaX = Caml_option.valFromOption(deltaX);
  }
  if (deltaY !== undefined) {
    tmp.deltaY = Caml_option.valFromOption(deltaY);
  }
  var tmp$2 = OptionUtils$SmartcutsMacros.$neg$question$great(pointerType, pointerTypeToJs);
  if (tmp$2 !== undefined) {
    tmp.pointerType = Caml_option.valFromOption(tmp$2);
  }
  var params = tmp;
  return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, "Input.dispatchMouseEvent", params).then(DevProtocol__Shared$SmartcutsMacros.sendCommandPromiseCallback);
}

exports.keyEventTypeToJs = keyEventTypeToJs;
exports.keyEventTypeFromJs = keyEventTypeFromJs;
exports.DispatchKeyEvent = DispatchKeyEvent;
exports.dispatchKeyEvent = dispatchKeyEvent;
exports.InsertTextParams = InsertTextParams;
exports.insertText = insertText;
exports.DispatchMouseEvent = DispatchMouseEvent;
exports.dispatchMouseEvent = dispatchMouseEvent;
/* Browser__Debugger-SmartcutsMacros Not a pure module */
